import React, { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Card,
  CardContent,
  CardMedia,
  Skeleton,
  Typography
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
  errorLogo: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(48),
    height: theme.spacing(15),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  },
  ztLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    width: theme.spacing(51),
    height: theme.spacing(15)
  },
  card: {
    width: theme.spacing(51),
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(3),
    height: theme.spacing(47)
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    height: '100vh'
  },
  text: {
    height: theme.spacing(10),
    width: theme.spacing(43),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  },
  closeMessage: {
    height: theme.spacing(7),
    width: theme.spacing(43),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  }
}));

const CollectorErrorPageSkeleton = (): ReactElement => {
  const classes = useStyles();

  return (
    <div
      data-testid="collector-error-page-skeleton"
      className={classes.container}
      role="progressbar"
      aria-busy={true}
      aria-label="Loading error page"
    >
      <div className={classes.ztLogo}>
        <Skeleton
          className={classes.ztLogo}
          data-testid="collector-error-ztLogo-Skeleton"
        />
      </div>
      <br />
      <Card
        className={classes.card}
        data-testid="collector-error-card-skeleton"
      >
        <CardMedia
          className={classes.errorLogo}
          data-testid="collector-error-logo-skeleton"
        >
          <Skeleton className={classes.errorLogo} />
        </CardMedia>
        <CardContent>
          <Typography variant="body1">
            <Skeleton
              className={classes.text}
              data-testid="collector-error-text-skeleton"
            />
          </Typography>

          <br />
          <br />
          <Typography variant="body1">
            <Skeleton
              className={classes.closeMessage}
              data-testid="collector-error-close-window-skeleton"
            />
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default CollectorErrorPageSkeleton;
